import base from '../base'
import { postJsonRequest, blobJsonRequest, getRequest } from '@utils/request'
const cloud = `prescription/${base.appCode}`

const PRESCRIPTIONDRUG = {

  // 获取订单列表
  getDeliveryList(params = {}) {
    // params.query.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/circulation/manage/v1/prescription/send/paginglist`, params)
  },

  // 获取处方发货订单详情
  getpersDetails(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/circulation/server/v1/prescription/detail`, params)
  },

  // 处方管理-订单详情
  getPerOrderDetails(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/circulation/server/v1/main/detail`, params)
  },

  // 缺货退款
  postRefund(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/order/pay/v2/applyRefund`, params)
  },

  // 问诊费退款（益丰便民）
  postRefundAdm(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/order/pay/v1/bmAdmissionRefund`, params)
  },

  // 扫码自动开方处方失效
  postAutoPresInvalid(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/order/pay/v1/autoPresInvalid`, params)
  },

  // 添加备注
  addRemark(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prescription/v1/addNotes`, params)
  },

  // 南大二 节点 输入取货码 确认取货
  getMedicine(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prescription/v1/comfireMachine`, params)
  },

  // 确认发货 南大二
  confirmDelivery(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prescription/v1/comfire`, params)
  },

  // 确认发货 通用版(不包括航天/南大二 收手动自动)
  postDelivery(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prescription/v1/expressDelivery`, params)
  },

  // 完成调配
  completeDeployment(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prescription/v1/completeAndBackDeployment`, params)
  },

  // 南大二 - 确认支付
  confirmPayNCEFY(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/ncefyPrescription/v1/confirmPay`, params)
  },

  // 航医通 多处方
  // 获取(航天节点)处方发货管理---列表
  getHytDeliveryList(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prescription/v1/main/doctorweblist`, params)
  },

  // 获取订单详情
  getOrderDetails(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prescription/v1/sendPresDetail`, params)
  },

  // 多处方物流退款
  logisticsRefund(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/order/pay/v1/apply/refund/logistics`, params)
  },

  // 多处方发货接口
  newConfirmDelivery(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/logistics/v1/comfire`, params)
  },

  // 处方发货导出收件信息
  exportExpressExcel(params = {}) {
    return blobJsonRequest(`${base.baseUrl}/${cloud}/api/load/manage/v1/excel/express`, params)
  },

  // 获取处方管理列表
  getChuFList(params = {}) {
    // params.query.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/circulation/manage/v1/prescription/order/paginglist`, params)
  },

  // 新处方订单提醒轮询
  checkNewOrders(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/circulation/manage/v1/prescription/order/new-notify`, params, '', false)
  },

  // 获取处方列表底部信息
  getBottomInfo(params = {}) {
    // params.query.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/circulation/manage/v1/prescription/order/paginglist/desc`, params)
  },

  // 获取药商列表
  getPharmacistList(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/paginglist`, params)
  },

  // 获取药房列表
  getDrugStore(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugStore/manage/paginglist`, params)
  },

  // 处方订单管理 批量下载订单 excel
  downOrderList(params = {}) {
    // params.appCode = base.appCode
    return blobJsonRequest(`${base.baseUrl}/${cloud}/api/load/manage/v1/excel/main`, params)
  },

  // 处方订单管理 批量下载清单pdf
  downDetailList(params = {}) {
    return blobJsonRequest(`${base.baseUrl}/${cloud}/api/load/manage/v1/pdf/main`, params)
  },

  // 处方管理-批量下载处方
  setDownPrescribe(params = {}) {
    return blobJsonRequest(`${base.baseUrl}/${cloud}/api/load/v1/pdf/prescriptionMainPdf`, params)
  },

  // 处方管理-批量打印处方（合并为一份多页PDF，直接返回字节流）
  batchPrintPrescribe(params = {}) {
    return blobJsonRequest(`${base.baseUrl}/${cloud}/api/load/v1/pdf/batchPrintPrescriptionPad`, params)
  },

  // 处方管理筛选-获取药房列表
  getDrugStoreList(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/circulation/manage/circulation/filter/drugStoreList`, params)
  },

  // 处方管理详情-获取药房列表
  getOrderStore(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugstore/v1/list`, params)
  },

  // 处方管理详情-获取药房中唯一药品
  getOnlyDrug(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/manage/drugItem/selectDefaultMedicine`, params)
  },

  // 处方管理详情-获取处方药品对应的厂商
  getOrderDrug(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/manage/drugItem/selectDrugByParams`, params)
  },

  // 处方管理详情-更新药品价格
  setDrugPrice(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/ncefyPrescription/v1/updatePresPriceInfo`, params)
  },

  // 处方管理详情-手动推方
  setSendInfo(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/manage/pay/v1/down/store/drug`, params)
  },

  // 处方管理详情-修改处方状态为待到店支付
  setPayStore(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prescription/v1/updateItemStatusByMainId`, params)
  },

  // 确认实收金额
  setAmountOrder(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/ncefyPrescription/v1/confirmPay`, params)
  },

  // 确认修改发货信息
  saveSendGoods(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/circulation/server/v1/prescription/modifyLogisticsInformation`, params)
  },

  // 获取问诊记录
  getAdmByMainId(mainId) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/kbj/adm/getByMainId?mainId=${mainId}`)
    // return postJsonRequest(`http://127.0.0.1:8033/api/kbj/adm/getByMainId?mainId=${mainId}`)
  },

  // 查看诊疗记录（真实问诊数据聚合：患者/订单/医生/沟通记录/复诊病历/病情资料/处方信息）
  getTreatmentRecordByMainId(mainId) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/circulation/manage/v1/prescription/order/getTreatmentRecordByMainId?mainId=${mainId}`)
  },

  // 查询开启自动开方的药商列表（直连复诊，含药商名称，用于控制「查看诊疗记录」按钮显隐）
  // 处方流转列表行只有药商名称无ID，故按名称匹配；复诊侧对 sr/空 不做 appCode 过滤
  getAutoPrescriptionCompanies() {
    return getRequest(`${base.baseUrl}/JDZDSRM/netinquiry/pharmaceuticalCompanyConfig/autoPrescriptionCompanies`, { appCode: base.appCode }, false)
  },

  // 省医保：根据医嘱 ID 查询处方上传记录（见 src/queryUploadRecord）
  queryUploadRecord(params = {}) {
    const { mainId } = params
    return getRequest(
      `${base.baseUrl}/JDZDSRM/medicalcloud/api/medicare/prescription/v1/queryUploadRecord`,
      { mainId },
      true
    )
  }
}

export default PRESCRIPTIONDRUG



// WEBPACK FOOTER //
// ./src/api/modules/prescriptionDrug.js